/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-22 16:00:31
 */

import { API_PREFIX } from './constant'
import { Request } from './request'

// 列表
export interface EAFConserveListParams {
  maintainTimeStart?: any
  maintainTimeEnd?: any
  current?: any
  size?: any
  deviceName?:any
  deviceNumber?:any
}

export function getEAFConserveList(
  params: EAFConserveListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdevicemaintain/list`,
    method: 'GET',
    params,
  }
}

export interface DetailParams {
  id?: any
  tenantId?: any
}

// 详情
export function getEAFConserveDetail(params: DetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdevicemaintain/detail`,
    method: 'GET',
    params
  }
}

// 导出
export function getEAFConserveExport(
  params: EAFConserveListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdevicemaintain/list/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}

// 保存编辑
export interface SubmitParams {
  id?: any
  deviceName?: any
  deviceNumber?: any
  handlingMeasures?: any
  maintainTime?:any
  model?: any
  operator?: any
  operatorId?: any
  remark?: any
}

export function getEAFConserveSubmit(body: SubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdevicemaintain/submit`,
    method: 'POST',
    body,
  }
}


// 删除
export function getRemove(ids: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdevicemaintain/remove`,
    method: 'GET',
    params: {
      ids,
    },
  }
}
